export const TERMS_LIST_KEY = 'TERMS_LIST';
export const TERMS_ONE_KEY = 'TERMS_ONE_KEY';
export const TERMS_ACTIVE_KEY = 'TERMS_ACTIVE';
export const TERMS_VERSIONS_KEY = 'TERMS_VERSIONS';
